import { apiPaths, getApiPath, httpStatus } from '../../../constants'
import { Api } from '../../../middlewares'
import { Logger, LoggerTypes } from '../../../utils'

// -- GET
export const GET_PROJECT_PARAMETERS_SUCCESS = 'GET_PROJECT_PARAMETERS_SUCCESS'
export const GET_PROJECT_PARAMETERS_FAILURE = 'GET_PROJECT_PARAMETERS_FAILURE'

// -- CREATE
export const CREATE_PROJECT_PARAMETER_SUCCESS = 'CREATE_PROJECT_PARAMETER_SUCCESS'
export const CREATE_PROJECT_PARAMETER_FAILURE = 'CREATE_PROJECT_PARAMETER_FAILURE'

// -- UPDATE
export const UPDATE_PROJECT_PARAMETER_SUCCESS = 'UPDATE_PROJECT_PARAMETER_SUCCESS'
export const UPDATE_PROJECT_PARAMETER_FAILURE = 'UPDATE_PROJECT_PARAMETER_FAILURE'

// -- DELETE
export const DELETE_PROJECT_PARAMETER_SUCCESS = 'DELETE_PROJECT_PARAMETER_SUCCESS'
export const DELETE_PROJECT_PARAMETER_FAILURE = 'DELETE_PROJECT_PARAMETER_FAILURE'

// -- SEARCH
export const SEARCH_PROJECT_PARAMETERS = 'SEARCH_PROJECT_PARAMETERS'

// -----------------------------------------------------------------------------

/**
 * SEARCH for a project parameter attribute based on its name.
 *
 * @param {string} terms Text to be searched within the project's parameter.
 * @returns {Promise<array<object>>}
 */
export const searchProjectParameters = (terms) => async (dispatch) => {
  dispatch({
    type: SEARCH_PROJECT_PARAMETERS,
    data: terms
  })
}

/**
 * GET the list of all the parameters that belong to a specific project.
 *
 * @param {uuid} pid Project ID.
 * @returns {Promise<array<object>>}
 */
export const getProjectParameters = (pid) => async (dispatch) => {
  const path = getApiPath(apiPaths.PROJECT_PARAMETER_LIST, { pid })
  const api = new Api(path)
  const result = await api.get()

  Logger.trace(LoggerTypes.ACTION, '[ACTION] parametersActions.getProjectParameters()', { path, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: GET_PROJECT_PARAMETERS_SUCCESS,
      data: result.data.items || []
    })
  }
  return dispatch({
    type: GET_PROJECT_PARAMETERS_FAILURE,
    data: result.data
  })
}

/**
 * CREATE a project parameter.
 *
 * @param {object} newParameter New parameter to be created.
 * @param {uuid} pid Project ID.
 * @returns {Promise<object>}
 */
export const createProjectParameter = (newParameter, pid) => async (dispatch) => {
  const path = getApiPath(apiPaths.PROJECT_PARAMETER_CREATE, { pid })
  const api = new Api(path)
  const result = await api.create(newParameter)

  Logger.trace(LoggerTypes.ACTION, '[ACTION] parametersActions.createParameter()', { pid, path, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: CREATE_PROJECT_PARAMETER_SUCCESS,
      data: result.data
    })
  }
  return dispatch({
    type: CREATE_PROJECT_PARAMETER_FAILURE,
    data: result.data
  })
}

/**
 * UPDATE a specific project parameter attribute.
 *
 * @param {object} newParameter Parameter object that will replace the previous one.
 * @param {uuid} mid Project's parameter ID.
 * @param {uuid} pid Project ID.
 * @returns {Promise<object>}
 */
export const updateProjectParameter = (newParameter, mid, pid) => async (dispatch) => {
  const path = getApiPath(apiPaths.PROJECT_PARAMETER_UPDATE, { pid, mid })
  const api = new Api(path)
  const result = await api.update(newParameter)

  Logger.trace(LoggerTypes.ACTION, '[ACTION] parametersActions.updateProjectParameter()', { newParameter, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: UPDATE_PROJECT_PARAMETER_SUCCESS,
      data: result.data
    })
  }
  return dispatch({
    type: UPDATE_PROJECT_PARAMETER_FAILURE,
    data: result.data
  })
}

/**
 * DELETE a specific project parameter.
 *
 * @param {uuid} mid Project's parameter ID.
 * @param {uuid} pid Project ID.
 * @returns {Promise<object>}
 */
export const deleteProjectParameter = (mid, pid) => async (dispatch) => {
  const path = getApiPath(apiPaths.PROJECT_PARAMETER_DELETE, { pid, mid })
  const api = new Api(path)
  const result = await api.delete()

  Logger.trace(LoggerTypes.ACTION, '[ACTION] parametersActions.deleteParameter()', { result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: DELETE_PROJECT_PARAMETER_SUCCESS,
      data: mid
    })
  }

  return dispatch({
    type: DELETE_PROJECT_PARAMETER_FAILURE,
    data: result.data
  })
}
